import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import '../../styles/core.scss';
import Button from '../button/index';
import MultilineText from '../../components/multiline-text/index';
import css from './index.scss';
import messages from './messages';

const AssignedTeacherInfo = ({ assignedTeachers = [], showAssignButton = true, handleOnAssignTeacher, dependentValues, intl }) => {
    let assignElement = [];
    if (assignedTeachers.length > 0) {
        assignElement = <MultilineText dataItems={assignedTeachers} />;
    } else if (showAssignButton) {
        assignElement = (<Button
            containerClassName={css.assign}
            disabled={false}
            handleOnClick={() => handleOnAssignTeacher(dependentValues.classroomId)}
            label={intl.formatMessage(messages.assignTeacher)} />);
    }

    return (
        <div className={css.component}>
            {assignElement}
        </div>
    );
};

AssignedTeacherInfo.propTypes = {
    assignedTeachers: PropTypes.array,
    showAssignButton: PropTypes.bool,
    dependentValues: PropTypes.object,
    handleOnAssignTeacher: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(AssignedTeacherInfo));



// WEBPACK FOOTER //
// ./app/components/assigned-teacher-info/index.js